import { Component, input } from '@angular/core';
import { ClientInfoResponse, PackageUserData } from '../../../infrastructure/shared/model/fss.api';
import { Building05 } from '../../../infrastructure/shared/icons/building-05/building-05';
import { Hash02 } from '../../../infrastructure/shared/icons/hash-02/hash-02';
import { HomeLine } from '../../../infrastructure/shared/icons/home-line/home-line';
import { MarkerPin01 } from '../../../infrastructure/shared/icons/marker-pin-01/marker-pin-01';
import { Mail02 } from '../../../infrastructure/shared/icons/mail-02/mail-02';
import { Map01 } from '../../../infrastructure/shared/icons/map-01/map-01';
import { UserCircle } from '../../../infrastructure/shared/icons/user-circle/user-circle';
import { Phone } from '../../../infrastructure/shared/icons/phone/phone';

@Component({
  standalone: true,
  selector: 'app-admin-client-about-tab',
  imports: [Building05, Hash02, HomeLine, MarkerPin01, Mail02, Map01, UserCircle, Phone],
  templateUrl: './admin-client-about-tab.html',
  styleUrl: './admin-client-about-tab.scss',
})
export class AdminClientAboutTab {
  data = input.required<ClientInfoResponse>();
}
